import { lazy } from "react";
import Loadable from "../ui-component/Loadable";
const AuthGuard = Loadable(
  lazy(() => import("../views/pages/authentication/AuthGuard"))
);
const MainLayout = Loadable(lazy(() => import("../layout/MainLayout")));
const DashboardDefault = Loadable(
  lazy(() => import("../views/dashboard/Default"))
);
const MainOrders = Loadable(lazy(() => import("../views/order/MainOrders")));
const OrderDetails = Loadable(
  lazy(() => import("../views/order/OrderDetails"))
);

//store
const AddStore = Loadable(lazy(() => import("../views/store/AddStore")));
const ListStore = Loadable(lazy(() => import("../views/store/ListStore")));
const ChangePassword = Loadable(lazy(() => import("../views/pages/authentication/ChangePassword")));
const StoreSettings = Loadable(
  lazy(() => import("../views/store/StoreSettings"))
);
const StoreProfile = Loadable(
  lazy(() => import("../views/store/StoreProfile"))
);
const Addon = Loadable(
  lazy(() => import("../views/store/addons/Addon"))
);
const MenuOptions = Loadable(
  lazy(() => import("../views/store/options/MenuOptions"))
);
const Category = Loadable(
  lazy(() => import("../views/store/category/Category"))
);
const Menu = Loadable(
  lazy(() => import("../views/store/menu/Menu"))
);
const MenuUpload = Loadable(
  lazy(() => import("../views/store/adminAction/MenuUpload"))
);

//order
const ReviewOrder = Loadable(
  lazy(() => import("../views/order/review/ReviewOrder"))
);
const ScheduledOrders = Loadable(
  lazy(() => import("../views/order/ScheduledOrders"))
);
const ScheduledGroceryOrders = Loadable(
  lazy(() => import("../views/order/ScheduledGroceryOrders"))
);
const DeliveryBoyAdd = Loadable(
  lazy(() => import("../views/deliveryBoy/DeliveryBoyAdd"))
);
const CustomerService = Loadable(
  lazy(() => import("../views/customerService/CustomerService"))
);

//offer
const ComboOffer = Loadable(
  lazy(() => import("../views/offer/ComboOffer"))
);
const DiscountOffer = Loadable(
  lazy(() => import("../views/offer/DiscountOffer"))
);
const StoreOffer = Loadable(
  lazy(() => import("../views/offer/StoreOffer"))
);
const CategoryOffer = Loadable(
  lazy(() => import("../views/offer/CategoryOffer"))
);
const ItemOffer = Loadable(
  lazy(() => import("../views/offer/ItemOffer"))
);
const NewCustomerCode = Loadable(
  lazy(() => import("../views/offer/NewCustomerCode"))
);

//performance Dialy
const DialyPerformance = Loadable(
  lazy(() => import("../views/report/performance/DialyPerformance"))
);
const WeeklyPerformance = Loadable(
  lazy(() => import("../views/report/performance/WeeklyPerformance"))
);
const MonthlyPerformance = Loadable(
  lazy(() => import("../views/report/performance/MonthlyPerformance"))
);

//Summary
const DialySummary = Loadable(
  lazy(() => import("../views/report/summary/DialySummary"))
);
const WeeklySummary = Loadable(
  lazy(() => import("../views/report/summary/WeeklySummary"))
);
const MonthlySummary = Loadable(
  lazy(() => import("../views/report/summary/MonthlySummary"))
);
//invoice
const MonthlyInvoice = Loadable(
  lazy(() => import("../views/report/MonthlyInvoice"))
);

//notification
const Notification = Loadable(
  lazy(() => import("../views/notification/Notification"))
);

//complaits
const Complaints = Loadable(
  lazy(() => import("../views/feedback/Complaints"))
);



const ViewMenu = Loadable(
  lazy(() => import("../views/store/menu/ViewMenu"))
);

//audit trailas
const AuditTrails = Loadable(
  lazy(() => import("../views/audit/AuditTrails"))
);

//acount settings
const BranchPartner = Loadable(
  lazy(() => import("../views/accounts/branchPartner/BranchPartner"))
);

const CustomerCareAdmin = Loadable(
  lazy(() => import("../views/accounts/customercare/CustomerCareAdmin"))
);
const CustomerCareExecutive = Loadable(
  lazy(() => import("../views/accounts/customercare/CustomerCareExecutive"))
);

const AccountantAdmin = Loadable(
  lazy(() => import("../views/accounts/accountants/AccountantAdmin"))
);
const AccountsManager = Loadable(
  lazy(() => import("../views/accounts/accountants/AccountsManager"))
);
const AccountsExecutive = Loadable(
  lazy(() => import("../views/accounts/accountants/AccountsExecutive"))
);
const MarketingAdmin = Loadable(
  lazy(() => import("../views/accounts/marketing/MarketingAdmin"))
);
const MarketingExecutive = Loadable(
  lazy(() => import("../views/accounts/marketing/MarketingExecutive"))
);
const OfficeStaff = Loadable(
  lazy(() => import("../views/accounts/officeStaff/OfficeStaff"))
);


const StoreFirstOrder = Loadable(
  lazy(() => import("../views/offer/StoreFirstOrder/StoreFirstOrder"))
);
const MachineStatus = Loadable(
  lazy(() => import("../views/settings/machine/machineStatus"))
);

const Machine = Loadable(
  lazy(() => import("../views/settings/machine/machines"))
);
const UserUpdate = Loadable(
  lazy(() => import("../views/pages/authentication/updateuser"))
);
const GroceryApproval = Loadable(lazy(() => import("../views/order/groceryApprove/approveOrder")))
const GroceryRejectOrderList = Loadable(
  lazy(() => import("../views/order/groceryApprove/rejectedList"))
);
const Approval = Loadable(lazy(() => import("../views/order/approval/approveOrder")))
const RejectOrderList = Loadable(
  lazy(() => import("../views/order/approval/rejectedList"))
);
const CustomerOrder =  Loadable(
  lazy(() => import("../views/customerService/orderDetailsCustomer"))
);
const StoreOrder =  Loadable(
  lazy(() => import("../views/store/storeOrder"))
);
const DeliveryBoyList = Loadable(
  lazy(() => import("../views/deliveryBoy/DeliveryBoyList"))
);
const UserNotification = Loadable(
  lazy(() => import("../views/userNotification/userNotification"))
);
const GroceryMainorder = Loadable(
  lazy(() => import("../views/order/groceryOrder/MainOrders"))
)
const GroceryorderDetails = Loadable(
  lazy(() => import("../views/order/groceryOrder/OrderDetails"))
)
const GroceryPendingorder = Loadable(
  lazy(() => import("../views/order/pendinggroceryOrder/MainOrders"))
)
const OrderDetailsPendingGrocery = Loadable(
  lazy(() => import("../views/order/pendinggroceryOrder/OrderDetails"))
);
const DeliveryMap =  Loadable(
  lazy(() => import("../views/order/deliveryMap"))
);

const FruitsMainorder = Loadable(
  lazy(() => import("../views/order/groceryFruitsOrder/MainOrders"))
)
const  FruitsorderDetails = Loadable(
  lazy(() => import("../views/order/groceryFruitsOrder/OrderDetails"))
)

const FishMainorder = Loadable(
  lazy(() => import("../views/order/groceryFishOrder/MainOrders"))
)
const  FishorderDetails = Loadable(
  lazy(() => import("../views/order/groceryFishOrder/OrderDetails"))
)

const CakeMainOrder = Loadable(
  lazy(() => import("../views/order/cakeSweetsOrder/MainOrders"))
)
const  CakeorderDetails = Loadable(
  lazy(() => import("../views/order/cakeSweetsOrder/OrderDetails"))
)
const CakeRejectOrderList = Loadable(
  lazy(() => import("../views/order/cakeSweetsOrder/rejectOrder/rejectedList"))
);
const FruitsRejectOrderList = Loadable(
  lazy(() => import("../views/order/groceryFruitsOrder/groceryApprove/rejectedList"))
);
const FishRejectOrderList = Loadable(
  lazy(() => import("../views/order/groceryFishOrder/fishApprove/rejectedList"))
);
const FruitsApproval = Loadable(lazy(() => import("../views/order/groceryFruitsOrder/groceryApprove/approveOrder")))
const FishApproval = Loadable(lazy(() => import("../views/order/groceryFishOrder/fishApprove/approveOrder")))
const CakeApproval = Loadable(lazy(() => import("../views/order/cakeSweetsOrder/rejectOrder/approveOrder")))

const PendingorderFruits = Loadable(
  lazy(() => import("../views/order/pendingfruitsOrder/MainOrders"))
)
const DetailsPendingFruits= Loadable(
  lazy(() => import("../views/order/pendingfruitsOrder/OrderDetails"))
);
const PendingorderFish = Loadable(
  lazy(() => import("../views/order/pendingFishOrder/MainOrders"))
)
const DetailsPendingFish = Loadable(
  lazy(() => import("../views/order/pendingFishOrder/OrderDetails"))
);
const OfflineStores =  Loadable(
  lazy(() => import("../views/store/OfflineStores"))
);
const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/dashboard",
      element: <DashboardDefault />,
    },
    {
      path: "/store",
      children: [
        {
          path: "add",
          element: <AddStore />,
        },
        {
          path: "list",
          element: <ListStore />,
        },
        {
          path: "settings",
          element: <StoreSettings />,
        },
        {
          path: "storeProfile/:id",
          element: <StoreProfile />,
        },
        {
          path: "storeProfile/addons/:id",
          element: <Addon />,
        },
        {
          path: "storeProfile/options/:id",
          element: <MenuOptions />,
        },
        {
          path: "storeProfile/category/:id",
          element: <Category />,
        },
        {
          path: "storeProfile/menu/:id",
          element: <Menu />,
        },
        {
          path: "storeProfile/viewMenu/:storeId/:catID",
          element: <ViewMenu />,
        },
        {
          path: "menuUpload",
          element: <MenuUpload />,
        },
        {
          path: "storeorder/:id",
          element: <StoreOrder />,
        },
        {
          path: "OfflineStores",
          element: <OfflineStores />,
        },
      ],
    },
    {
      path: "/deliveryBoy",
      children: [
        {
          path: "list",
          element: <DeliveryBoyList />,
        },
      ],
    },
    {
      path: "/customerService",
      // element: <CustomerService />,
      children: [
        {
          path: "list",
          element: <CustomerService />,
        },
        {
          path: "customerorder/:id",
          element: <CustomerOrder />,
        },
      ],
    },
    {
      path: "/branch",
      children: [
        {
          path: "order",
          element: <MainOrders />,
        },
      ],
    },
    {
      path: "/order",
      children: [
        {
          path: "view",
          element: <MainOrders />,
        },
        
        {
          path: "review",
          element: <ReviewOrder />,
        },
        {
          path: "scheduled",
          element: <ScheduledOrders />,
        },
        {
          path: "scheduled-grocery",
          element: <ScheduledGroceryOrders />,
        },
        {
          path: "grocery/view",
          element: <GroceryMainorder />,
        },
        {
          path: "grocery/groceryOrderDetails/:id",
          element: <GroceryorderDetails />,
        },
        {
          path: "orderDetails/:id",
          element: <OrderDetails />,
        },
        {
          path: "grocery/pending",
          element: <GroceryPendingorder />,
        },
        {
          path: "grocery/groceryPendingOrderDetails/:id",
          element: <OrderDetailsPendingGrocery />,
        },
        
        {
          path: "deliverymap/:id/:type",
          element: <  DeliveryMap />,
        },
        {
          path: "rejectList",
          element: <RejectOrderList />,
          
        },
        {
          path: "groceryrejectList",
          element: <GroceryRejectOrderList />,
          
        },
        {
          path: "fruits/view",
          element: <FruitsMainorder />,
          
        },
        {
          path: "fruits/fruitsOrderDetails/:id",
          element: <FruitsorderDetails />,
          
        },
        {
          path: "fish/view",
          element: <FishMainorder />,
          
        },
        {
          path: "fish/fishOrderDetails/:id",
          element: <FishorderDetails />,
          
        },
        {
          path: "cakes/view",
          element: <CakeMainOrder />,
          
        },
        {
          path: "cakes/cakeOrderDetails/:id",
          element: <CakeorderDetails />,
          
        },
        {
          path: "cakesRejectedList",
          element: <CakeRejectOrderList />,
          
        },
        {
          path: "fruitsRejectList",
          element: <FruitsRejectOrderList />,
          
        },
        {
          path: "fish/pending",
          element: < PendingorderFish/>,
        },
        {
          path: "fish/fishPendingOrderDetails/:id",
          element: <DetailsPendingFish />,
        },
        {
          path: "fishRejectedList",
          element: <FishRejectOrderList />,
          
        },
        {
          path: "fruits/pending",
          element: <PendingorderFruits />,
        },
        {
          path: "fruits/fruitsPendingOrderDetails/:id",
          element: <DetailsPendingFruits />,
        },

        
        
      ],
    },
    {
      path: "/offer",
      children: [
        {
          path: "combo_offer",
          element: <ComboOffer />,
        },
        {
          path: "discount",
          element: <DiscountOffer />,
        },
        {
          path: "store",
          element: <StoreOffer />,
        },
        {
          path: "category",
          element: <CategoryOffer />,
        },
        {
          path: "item",
          element: <ItemOffer />,
        },
        {
          path: "newCustomer",
          element: <NewCustomerCode />,
        },
        {
          path: "StoreNewOrderOffer",
          element: <StoreFirstOrder />,
        },
      ],
    },
    {
      path: "/report",
      children: [
        {
          path: "invoice",
          element: <MonthlyInvoice />,
        },
      ],
    },
    {
      path: "/notification",
      // element: <Notification />,
      children: [
        {
          path: "customer",
          element: <Notification />,
        },
        {
          path: "area",
          element: <Notification />,
        },
        {
          path: "scheduled",
          element: <Notification />,
        },]
    },
    {
      path: "/settings",
      // element: <Notification />,
      children: [
        {
          path: "status",
          element: <MachineStatus/>,
        },
        {
          path: "machine",
          element: <Machine />,
        },
      ]
    },
    {
      path: "/feedback",
      element: <Complaints />,
    },
    {
      path: "/profile",
      element: <ChangePassword />,
    },
    {
      path: "/audit-tails",
      element: <AuditTrails />,
    },
    {
      path: "/accounts",
      children: [
        {
          path: "branch-partner",
          element: <BranchPartner />,
        },
        {
          path: "custumercare-admin",
          element: <CustomerCareAdmin />,
        },
        {
          path: "custumercare-executive",
          element: <CustomerCareExecutive />,
        },
        {
          path: "accountant-admin",
          element: <AccountantAdmin />,
        },
        {
          path: "accounts-manager",
          element: <AccountsManager />,
        },
        {
          path: "accounts-executive",
          element: <AccountsExecutive />,
        },
        {
          path: "marketing-admin",
          element: <MarketingAdmin />,
        },
        {
          path: "marketing-executive",
          element: <MarketingExecutive />,
        },
        {
          path: "office-staff",
          element: <OfficeStaff />,
        }
      ],
    },
    {
      path: "/userUpdate",
      element: <UserUpdate />,
    },
    {
      path: "/profile",
      element: <ChangePassword />,
    },
    {
      path: "/approve",
      children: [
        {
          path: "list",
          element: <Approval/>,
        },
     
        {
          path: "grocerylist",
          element: <GroceryApproval/>,
        },
        {
          path: "fruitslist",
          element: <FruitsApproval/>,
        },
        {
          path: "fishlist",
          element: <FishApproval/>,
        },
        {
          path: "cakelist",
          element: <CakeApproval/>,
        },
       
      ]
    },
    {
      path: "/notification/view",
      element: <UserNotification />,
    },
    
  ],
};

export default MainRoutes;
